import React from 'react';
import PropTypes from 'prop-types';
import VersionSection from '../components/VersionSection';
import FixedData from '../components/FixedData';
import styled from 'styled-components';
import { CloseIconSVG, InputField } from 'cx-ui-components';

const StyledHeader = styled.h3`
  font-size: 28px;
  color: #474747;
  font-weight: 700;
  margin-bottom: 30px;
`;

const CloseButtonWrapper = styled.div`
  float: right;
`;

export default function AlpsUpdateVersionForm({
  key,
  initialValues,
  actionTypes,
  artifactTypeName,
  artifactSubtype,
  typeHasSubtypes,
  setSelectedSubEntityId,
}) {
  return (
    <form
      key={key}>
      <CloseButtonWrapper>
        <CloseIconSVG
          onClick={() => setSelectedSubEntityId(undefined)}
          size={18}
          closeIconType="secondary"
          data-automation="dtpanelActionClose"
        />
      </CloseButtonWrapper>
      <StyledHeader>Viewing a published Artifacts Lifecycle Policy version</StyledHeader>

      <FixedData label="Artifact Type *" value={artifactTypeName} />
      {typeHasSubtypes && <FixedData label="Artifact Subtype *" value={artifactSubtype} />}
      <InputField
        name="versionName"
        label="Version Name *"
        id="frm-alps-name"
        data-automation="nameInput"
        componentType="input"
        inputType="text"
        disabled
        required
      />
      <VersionSection actionTypes={actionTypes} disabled callFrom="updateVersion" activeActionFromInit={initialValues.get('activeAction')}/>
    </form>
  );
}

AlpsUpdateVersionForm.propTypes = {
  key: PropTypes.string,
  setSelectedSubEntityId: PropTypes.func,
  actionTypes: PropTypes.array,
  initialValues: PropTypes.object,
  artifactType: PropTypes.string,
  artifactTypeName: PropTypes.string,
  artifactSubtype: PropTypes.string,
};
